import Mn from 'backbone.marionette';

import Page from '../../../base/views/page';

import { MapPaymentItem } from '../../models/payment_item';
import PaymentItemList from '../../collections/paymentitem';
import CostCentreList from '../../../transactions/collections/costcentre';

const PaymentItemOption = Mn.LayoutView.extend({
  tagName: 'option',
  attributes() {
    return {
      selected: this.model.get('is_primary') ? true : false,
      value: this.model.id ? this.model.id : ''
    };
  },

  template: require('../../templates/costcentre/payment_item.html')
});

const NoPaymentItems = Mn.LayoutView.extend({
  tagName: 'option',
  template: require('../../templates/costcentre/empty_payment_item.html'),

  attributes: {
    value: ''
  }
});

const PaymentItems = Mn.CollectionView.extend({
  tagName: 'select',

  childView: PaymentItemOption,
  emptyView: NoPaymentItems,

  events: {
    change: 'selectPaymentItem'
  },

  selectPaymentItem(e) {
    const mapModel = this.getOption('mapModel');
    const value = e.target.value;

    if (value) {
      mapModel.addPaymentItem(this.model, parseInt(value));
    } else {
      mapModel.removePaymentItem(this.model);
    }
  },

  onBeforeRender() {
    const mapModel = this.getOption('mapModel');
    const paymentItem = mapModel.getPaymentItem(this.model);

    if (paymentItem) {
      this.collection
        .chain()
        .filter(item => item.id !== paymentItem && item.get('is_primary'))
        .each(item => item.set({ is_primary: false }));

      const selected = this.collection.get(paymentItem.get('payment_item'));
      if (selected) {
        selected.set({ is_primary: true });
      }
    }
  }
});

const RowView = Mn.LayoutView.extend({
  tagName: 'tr',
  template: require('../../templates/costcentre/row.html'),
  attributes() {
    return { id: `costcentre-${this.model.id}` };
  },

  className() {
    return this.getOption('alt');
  },

  regions: {
    payment_item: '.payment_item-hook'
  },

  onRender() {
    const collection = new PaymentItemList(this.model.get('payment_items'));

    if (collection.length) {
      collection.unshift({ id: null, name: '--- Choose a Payment Item ---' });
    }

    const paymentView = new PaymentItems({
      collection,
      model: this.model,
      mapModel: this.getOption('mapModel')
    });

    this.showChildView('payment_item', paymentView);
  }
});

const TableView = Mn.CompositeView.extend({
  tagName: 'table',
  template: require('../../templates/costcentre/table.html'),

  className: 'datatable',
  childView: RowView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    return {
      alt: index % 2 ? '' : 'alt',
      mapModel: this.model
    };
  }
});

export const CostCentreLayout = Mn.LayoutView.extend({
  template: require('../../templates/costcentre/layout.html'),

  regions: {
    page: '.page-hook',
    table: '.table-hook'
  },

  ui: {
    save: 'button.map'
  },

  events: {
    'click @ui.save': 'savePaymentItems'
  },

  initialize() {
    this.model = new MapPaymentItem();
  },

  onRender() {
    const costcentreUrl = this.getOption('costcentre_url');

    const collection = new CostCentreList(null, {
      urlBase: costcentreUrl,
      search_params: {
        is_active: 'True'
      },
      state: {
        pageSize: 200
      }
    });
    collection.fetch();

    this.showChildView(
      'table',
      new TableView({
        collection,
        model: this.model
      })
    );
    this.showChildView('page', new Page({ collection }));
  },

  savePaymentItems() {
    this.model.save();
  }
});



// WEBPACK FOOTER //
// ./parentpay/views/costcentre/index.js